import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  name: z.string().min(1, { message: msg.required }),
  competition: z.number(),
  start: z.string(),
});

export type Schema = z.infer<typeof schema>;
